module.exports = __webpack_public_path__ + "static/img/Ben-Te-Kura.60f96da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Te-Kura.jpg
// module id = /xPH
// module chunks = 0